export const calculateArea = (percentageArea, area) => {
    const calculatedArea = (area * percentageArea) / 100
    return parseFloat(calculatedArea?.toFixed(2))
}

export const proposition2UiHelper = (persianName, unit, parameterMapInfo) => {
    let max = parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max, min = parameterMapInfo?.mapInfo?.ranges[0]?.min
    switch (unit) {
        case '(dS/m)':
            unit = 'دسی‌زیمنس بر متر'
            break
        case '%':
            unit = 'درصد'
            break
        case '(mg/kg)':
            unit = 'میلی‌گرم بر کیلوگرم'
            break
        default:
            unit = ''
    }
    if (max === min) {
        return `نقشه ${persianName} برگ مشخص کرد که مقدار ${persianName} برگ در کل زمین حدود ${min} ${unit} است.`
    } else {
        return `نقشه ${persianName} برگ مشخص کرد که مقدار ${persianName} برگ ها در کل زمین از ${min} تا ${max} ${unit} متغیر است.`
    }
}

export const proposition3UiHelper = (persianName, unit, parameterMapInfo) => {
    switch (unit) {
        case '(dS/m)':
            unit = 'دسی‌زیمنس بر متر'
            break
        case '%':
            unit = 'درصد'
            break
        case '(mg/kg)':
            unit = 'میلی‌گرم بر کیلوگرم'
            break
        default:
            unit = ''
    }
    return `کمترین مقدار ${persianName} برگ با ${parameterMapInfo?.mapInfo?.ranges[0]?.min} تا ${parameterMapInfo?.mapInfo?.ranges[0]?.max} ${unit} مربوط به محدوده ${parameterMapInfo?.mapInfo?.ranges[0]?.label} و بیشترین مقدار با ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.min} تا ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max} ${unit} مربوط به محدوده ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.label} می‌باشد.`
}

export const isShowProposition3UiHelper = (parameterMapInfo) => {
    let max = parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max, min = parameterMapInfo?.mapInfo?.ranges[0]?.min
    if (min > 0 && min < 1) {
        if ((max / min) < 2) {
            return false
        }
    }
    if (min > 1 && min < 10) {
        if ((max / min) < 1.6) {
            return false
        }
    }
    if (min > 100) {
        if ((max / min) < 1.15) {
            return false
        }
    }
    return true
}

export const proposition4UiHelper = (persianName, unit, parameterMapInfo) => {
    switch (unit) {
        case '(dS/m)':
            unit = 'دسی‌زیمنس بر متر'
            break
        case '%':
            unit = 'درصد'
            break
        case '(mg/kg)':
            unit = 'میلی‌گرم بر کیلوگرم'
            break
        default:
            unit = ''
    }
    let maxPercentage = parameterMapInfo?.mapInfo?.percentage[0]
    let rangeObject = parameterMapInfo?.mapInfo?.ranges[0]
    parameterMapInfo?.mapInfo?.percentage?.forEach((value, i) => {
        if (value > maxPercentage) {
            maxPercentage = value
            rangeObject = parameterMapInfo?.mapInfo?.ranges[i]
        }
    })
    return `همینطور مساحت غالب زمین با سهم حدود ${maxPercentage} درصد (محدوده ${rangeObject?.label}) با مقدار ${persianName} برگ ${rangeObject?.min} تا ${rangeObject?.max} ${unit} مشاهده می‌شود.`
}

export const isShowProposition4UiHelper = (parameterMapInfo) => {
    const percentageValueMore60 = parameterMapInfo?.mapInfo?.percentage?.some(value => value > 60)
    if (!percentageValueMore60) {
        return false
    }
    if (parameterMapInfo?.mapInfo?.percentage?.length === 1) {
        return false
    }
    return true
}

export const determiningParameterDepth = (depthId) => {
    switch (depthId) {
        case 1:
            return 'عمق 30-0'
        case 2:
            return 'عمق 60-30'
        case 3:
            return 'عمق 90-60'
        default:
            return 'عمقی مشخص نشده است'
    }
}

export const academicDegreeDetector = (academicId) => {
    switch (academicId) {
        case 1:
            return 'دکتر'
        case 7:
            return ''
        default:
            return 'مهندس'
    }
}

export const soilSampleType = (categoryFA) => {
    switch (categoryFA) {
        case 'آزمایش خاک':
            return 'خاک'
        case 'آزمایش آب':
            return 'آب'
        case 'آزمایش برگ':
            return 'برگ'
        default:
            break
    }
}

export const samplingDepthForTable = (sample) => {
    switch (sample) {
        case "۰ تا ۳۰ سانتی متر":
            return '0-30'
        case '۳۰ تا ۶۰ سانتی متر':
            return '30-60'
        case '۶۰ تا ۹۰ سانتی متر':
            return '60-90'
        default:
            break
    }
}

export const samplingDepth = (sampleLength) => {
    switch (sampleLength) {
        case 1:
            return '0-30'
        case 2:
            return '0-30, 30-60'
        case 3:
            return '60-90, 30-60, 0-30'
        default:
            return 'عمقی مشخص نشده است'
    }
}